import React from "react";
import "./index.css";
import logo from "../assets/logo.svg";
import { siteContent } from "../content";

export const SubFooter = () => {
  return (
    <div className="subfooter">
      <div className="colImg flex flexRow flexWrap">
        <div className="textFooter">
          <h2>
            {siteContent.subfooter.title},<br />
            <span>{siteContent.subfooter.subtitle}</span>
          </h2>
          <a
            href="#form"
            className="btn whitebtn"
          >
            {siteContent.subfooter.cta}
          </a>
        </div>
      </div>
    </div>
  );
};

export const Footer = () => {
  return (
    <div className="footer">
      <div className="container-lg flex flexRow flexWrap space">
        <img src={logo} className="logoFooter" alt="logo" />
        <p>
          {siteContent.projectName} - {siteContent.developer}<br />
          <span className="footerContact">{siteContent.contact.phones} · {siteContent.contact.email}</span>
        </p>
      </div>
    </div>
  );
};

export default SubFooter;
